import { render, staticRenderFns } from "./DuelsGameWinner.vue?vue&type=template&id=2d12c271&scoped=true"
import script from "./DuelsGameWinner.vue?vue&type=script&lang=js"
export * from "./DuelsGameWinner.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameWinner.vue?vue&type=style&index=0&id=2d12c271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12c271",
  null
  
)

export default component.exports